module.exports = __webpack_public_path__ + "img/customer3.f57d84ea.png";